import React, { useState } from "react";
import { firestore } from "../firebase/config";
import DonorList from "./DonorList";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
} from "firebase/firestore";

function SearchDonorByName() {
  const [name, setName] = useState("");
  const [queryResult, setQueryResult] = useState(null); //State to store the search result
  const [isNameEntered, setIsNameEntered] = useState(true);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setQueryResult(null);

    if (name !== null && name !== "") {
      try {
        // const firestore = firebase.firestore();
        const donorCollection = collection(firestore, "donors");
        const donorQuery = query(
          donorCollection,
          where("fullName", ">=", name),
          orderBy("fullName"),
          limit(10)
        );
        getDocs(donorQuery).then((querySnapshot) => {
          const donorList = querySnapshot.docs.map((donor) => ({
            donorId: donor.id,
            fullName: donor.data().fullName,
            pan: donor.data().pan,
          }));
          setQueryResult(donorList);
          setName("");
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      // Handle case when name is not entered
      setIsNameEntered(false); // You'll need to define setIsNameEntered
    }
  };

  return (
    <>
      <div>
        <div className="card">
          <div className="justify-content-center d-flex">
            <h2>Search Donor</h2>
          </div>
        </div>
        <div className="row justify-content-center d-flex card">
          <form className="" onSubmit={handleFormSubmit}>
            <div className="row d-flex flex-row align-items-center mx-4">
              <div className="col-3">
                <label className="float-end">Full Name:</label>
              </div>
              <div className="col-6">
                {" "}
                <input
                  type="text"
                  className="form-control m-2"
                  id="name"
                  placeholder="Enter Legal Name"
                  name="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value.toUpperCase());
                    setIsNameEntered(true);
                  }}
                />
              </div>
              <div className="col-3 float-start">
                <button type="submit" className="btn btn-primary m-2">
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
        {queryResult != null && (
          <div
            className="card text-center border-top-0 rounded-0"
            style={{ position: "inherit" }}
          >
            <div className="card-header py-2 justify-content-center d-flex">
              <h4 className="">Result</h4>
            </div>

            <div className="card-body py-2 justify-content-center d-flex">
              <div className="card-title font-weight-bold m-0">
                <>
                  Query Results here..
                  {queryResult.length > 0 ? (
                    <DonorList queryResult={queryResult} entity="donor" />
                  ) : (
                    <div>No donor found</div>
                  )}
                </>

                {!isNameEntered ? (
                  <div>Please enter a search criteria</div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SearchDonorByName;
